// Shared handling for polling a BLAST / PatMatch job from its results page.

// Most searches finish within seconds, so check every second at first,
// then every 3 s for long tblastn / large PatMatch runs.
const FAST_POLL_MS = 1000;
const SLOW_POLL_MS = 3000;
const FAST_POLL_FOR_MS = 20 * 1000;

/** Delay before the next status check of a job polled since startedAt. */
export function nextPollDelay(startedAt, now = Date.now()) {
  return now - startedAt < FAST_POLL_FOR_MS ? FAST_POLL_MS : SLOW_POLL_MS;
}

// Gateway errors and dropped connections are worth another try; any other
// HTTP error will not change by polling again.
const RETRYABLE_STATUSES = [502, 503, 504];

/**
 * What to do after a failed job request: { retry: true } to poll again, or
 * { retry: false, message } to stop and show the message.
 */
export function classifyPollError(err, toolName) {
  const response = err && err.response;
  if (!response || RETRYABLE_STATUSES.includes(response.status)) {
    return { retry: true };
  }
  const message = response.data && response.data.error;
  return {
    retry: false,
    message:
      message ||
      `The ${toolName} results could not be loaded (HTTP ${response.status}). Please try again later.`,
  };
}
